// 66g per scoop according to google search
export const SCOOP_SIZE_GRAMS = 66;

// 2.58x Sodium -> Salt
export const SODIUM_TO_SALT_RATIO = 2.58;

// Milkfat is ~65% saturated
export const MILKFAT_SATURATED_FAT_PERCENTAGE = 0.65;

/**
 * Freezing point depression (°C) below 0°C of sucrose solutions.
 * 0.03 corresponds to a 3% sucrose solution.
 *
 * Taken from [1], but divided by 100 to get the percentage concentration instead
 * of g/100 g water.
 *
 * [1]: Ice Cream 7th Edition, pg. 182
 */
export const SUCROSE_FREEZING_POINT_DEPRESSION_TABLE: Array<{
  concentration: number;
  fpcCelcius: number;
}> = [
  { concentration: 0.03, fpcCelcius: 0.18 },
  { concentration: 0.06, fpcCelcius: 0.35 },
  { concentration: 0.09, fpcCelcius: 0.53 },
  { concentration: 0.12, fpcCelcius: 0.72 },
  { concentration: 0.15, fpcCelcius: 0.9 },
  { concentration: 0.18, fpcCelcius: 1.1 },
  { concentration: 0.21, fpcCelcius: 1.29 },
  { concentration: 0.24, fpcCelcius: 1.47 },
  { concentration: 0.27, fpcCelcius: 1.67 },
  { concentration: 0.3, fpcCelcius: 1.86 },
  { concentration: 0.33, fpcCelcius: 2.03 },
  { concentration: 0.36, fpcCelcius: 2.21 },
  { concentration: 0.39, fpcCelcius: 2.4 },
  { concentration: 0.42, fpcCelcius: 2.6 },
  { concentration: 0.45, fpcCelcius: 2.78 },
  { concentration: 0.48, fpcCelcius: 2.99 },
  { concentration: 0.51, fpcCelcius: 3.2 },
  { concentration: 0.54, fpcCelcius: 3.42 },
  { concentration: 0.57, fpcCelcius: 3.63 },
  { concentration: 0.6, fpcCelcius: 3.85 },
  { concentration: 0.63, fpcCelcius: 4.1 },
  { concentration: 0.66, fpcCelcius: 4.33 },
  { concentration: 0.69, fpcCelcius: 4.54 },
  { concentration: 0.72, fpcCelcius: 4.77 },
  { concentration: 0.75, fpcCelcius: 5.0 },
  { concentration: 0.78, fpcCelcius: 5.26 },
  { concentration: 0.81, fpcCelcius: 5.53 },
  { concentration: 0.84, fpcCelcius: 5.77 },
  { concentration: 0.87, fpcCelcius: 5.99 },
  { concentration: 0.9, fpcCelcius: 6.23 },
  { concentration: 0.93, fpcCelcius: 6.5 },
  { concentration: 0.96, fpcCelcius: 6.8 },
  { concentration: 0.99, fpcCelcius: 7.04 },
  { concentration: 1.02, fpcCelcius: 7.32 },
  { concentration: 1.05, fpcCelcius: 7.56 },
  { concentration: 1.08, fpcCelcius: 7.8 },
  { concentration: 1.11, fpcCelcius: 8.04 },
  { concentration: 1.14, fpcCelcius: 8.33 },
  { concentration: 1.17, fpcCelcius: 8.62 },
  { concentration: 1.2, fpcCelcius: 8.92 },
  { concentration: 1.23, fpcCelcius: 9.19 },
  { concentration: 1.26, fpcCelcius: 9.45 },
  { concentration: 1.29, fpcCelcius: 9.71 },
  { concentration: 1.32, fpcCelcius: 9.96 },
  { concentration: 1.35, fpcCelcius: 10.22 },
  { concentration: 1.38, fpcCelcius: 10.47 },
  { concentration: 1.41, fpcCelcius: 10.72 },
  { concentration: 1.44, fpcCelcius: 10.97 },
  { concentration: 1.47, fpcCelcius: 11.19 },
  { concentration: 1.5, fpcCelcius: 11.41 },
  { concentration: 1.53, fpcCelcius: 11.63 },
  { concentration: 1.56, fpcCelcius: 11.88 },
  { concentration: 1.59, fpcCelcius: 12.14 },
  { concentration: 1.62, fpcCelcius: 12.4 },
  { concentration: 1.65, fpcCelcius: 12.67 },
  { concentration: 1.68, fpcCelcius: 12.88 },
  { concentration: 1.71, fpcCelcius: 13.08 },
  { concentration: 1.74, fpcCelcius: 13.28 },
  { concentration: 1.77, fpcCelcius: 13.48 },
  { concentration: 1.8, fpcCelcius: 13.68 },
];
